import React from 'react';
import { motion } from 'framer-motion';
import { Heart, Home, Sparkles } from 'lucide-react';
const benefits = [{
  icon: Heart,
  title: 'Aprendé algo creativo y relajante',
  desc: 'Descubrí una técnica artesanal llena de color, ideal para crear con tus manos y disfrutar el proceso.'
}, {
  icon: Home,
  title: 'Creá piezas para vender desde casa',
  desc: 'Transformá tus diseños en regalos, souvenirs, portavelas, atrapasoles y productos personalizados.'
}, {
  icon: Sparkles,
  title: 'Empezá aunque seas principiante',
  desc: 'No necesitás experiencia previa ni saber dibujar. La guía está pensada para acompañarte desde cero.'
}];
export function Benefits() {
  return <section className="py-12 sm:py-16 px-4 sm:px-6 lg:px-8 bg-deco-pink-light relative" data-id="element-16" data-mp="3crut9820lqcl">
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none" data-id="element-17" data-mp="3cu7epv6zeiue">
        <div className="absolute -top-24 -left-24 w-64 h-64 bg-deco-coral/10 rounded-full blur-3xl" data-id="element-18" data-mp="1fx8e5y1nlsf5"></div>
        <div className="absolute bottom-0 right-0 w-80 h-80 bg-deco-amber/10 rounded-full blur-3xl" data-id="element-19" data-mp="2r7odve32zeq"></div>
      </div>
      <div className="text-center max-w-3xl mx-auto mb-10 sm:mb-14 px-2 relative z-10" data-id="element-20" data-mp="6tb10nchoa1l">
        <h2 className="text-3xl sm:text-4xl lg:text-5xl text-deco-text mb-4 sm:mb-6 font-bold leading-tight" data-id="element-21" data-mp="3oyo006qmfdcz">
          ¿Te gustaría empezar una manualidad linda, creativa y con
          posibilidades reales?
        </h2>
        <p className="text-base sm:text-lg text-deco-taupe font-medium" data-id="element-22" data-mp="lhfm1xz0kxnj">
          Con Falso Vitral Deco vas a aprender una técnica decorativa para
          transformar objetos en piezas únicas para decorar, regalar o vender.
        </p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8 max-w-5xl mx-auto relative z-10" data-id="element-23" data-mp="bprwy3pxjsp8">
        {benefits.map((benefit, i) => <motion.div key={i} initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        delay: i * 0.1
      }} className="bg-white rounded-[2rem] p-8 sm:p-10 shadow-md border border-deco-coral/10 hover:shadow-lg transition-shadow flex flex-col items-center text-center relative overflow-hidden" data-id="element-24" data-mp="14ga3xftrye7x" data-mpi={i}>
            <div className="absolute top-0 right-0 w-32 h-32 bg-deco-yellow-light rounded-bl-full -z-10 opacity-50" data-id="element-25" data-mp="1939ij1p6iw3z"></div>

            <div className="w-16 h-16 sm:w-20 sm:h-20 rounded-full bg-deco-pink-light flex items-center justify-center mb-6 text-deco-ruby border border-deco-coral/20" data-id="element-26" data-mp="155tyxm3yo0l6">
              <benefit.icon size={28} className="sm:w-8 sm:h-8" strokeWidth={1.5} data-id="element-27" data-mp="vcd2eacfw7dt" />
            </div>
            <h3 className="text-xl sm:text-2xl mb-3 sm:mb-4 text-deco-text font-serif font-bold leading-tight" data-id="element-28" data-mp="qeurieev3i36">
              {benefit.title}
            </h3>
            <p className="text-deco-text/70 leading-relaxed font-normal text-sm sm:text-base" data-id="element-29" data-mp="he6b5d1zx5n4">
              {benefit.desc}
            </p>
          </motion.div>)}
      </div>
    </section>;
}